import { render, staticRenderFns } from "./EditPlantation.vue?vue&type=template&id=72b9afb3"
import script from "./EditPlantation.vue?vue&type=script&lang=js"
export * from "./EditPlantation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports